import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next/pages';

const LandingView = dynamic(() =>
  import('features/landing/landing-view').then((mod) => mod.LandingView),
);

const IndexPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <NextSeo title={t('Welcome')} />
      <LandingView />
    </>
  );
};

export { getServerSideProps } from 'getServerSideProps';
export default IndexPage;
